import { render, staticRenderFns } from "./GroupsMigrationsList.vue?vue&type=template&id=130ee218&"
import script from "./GroupsMigrationsList.vue?vue&type=script&lang=ts&"
export * from "./GroupsMigrationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports